import { __styles, mergeClasses } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
import { menuItemClassNames } from '../MenuItem/useMenuItemStyles.styles';
export const menuSplitGroupMultilineAttr = 'data-multiline';
export const menuSplitGroupClassNames = {
  root: 'fui-MenuSplitGroup'
};
/**
 * Styles for the root slot
 * TODO - remove the use of nested combinators to style child menu items
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Bhlrgs3: "f1v24km9",
    mc9l5x: "f22iagw",
    rue6gn: 0,
    oe75ve: 0,
    Bbblmiw: 0,
    Bn2ps6a: "fa49so4",
    Bu15iap: ["fsdyxoe", "fuk6rhi"],
    B71tm0z: ["fn8z6db", "f1be8c1t"],
    Gjs4sj: ["f1vtn0lh", "f8hq2kl"],
    foni4y: "f7j48hl",
    Ie9k5m: "f13du8c1",
    f30fub: "fe64lw1",
    Jberyy: "f92oj5h"
  }
}, {
  d: [".f1v24km9[data-multiline]>.fui-MenuItem:nth-of-type(2){align-self:center;}", ".f22iagw{display:flex;}", [".fa49so4>.fui-MenuItem:nth-of-type(1){flex:1;}", {
    p: -1
  }], ".fsdyxoe>.fui-MenuItem:nth-of-type(2){border-top-left-radius:0;}", ".fuk6rhi>.fui-MenuItem:nth-of-type(2){border-top-right-radius:0;}", ".fn8z6db>.fui-MenuItem:nth-of-type(2){border-bottom-left-radius:0;}", ".f1be8c1t>.fui-MenuItem:nth-of-type(2){border-bottom-right-radius:0;}", ".f1vtn0lh>.fui-MenuItem:nth-of-type(2){padding-left:0;}", ".f8hq2kl>.fui-MenuItem:nth-of-type(2){padding-right:0;}", ".f7j48hl>.fui-MenuItem:nth-of-type(2)::before{content:\"\";}", ".f13du8c1>.fui-MenuItem:nth-of-type(2)::before{width:var(--strokeWidthThin);}", ".fe64lw1>.fui-MenuItem:nth-of-type(2)::before{height:20px;}", ".f92oj5h>.fui-MenuItem:nth-of-type(2)::before{background-color:var(--colorNeutralStroke1);}"]
});
/**
 * Apply styling to the MenuSplitGroup slots based on the state
 */
export const useMenuSplitGroupStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(menuSplitGroupClassNames.root, styles.root, state.root.className);
  return state;
};